import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {ImpressaoService} from "../../services/impressao.service";
import {ConstantsService, ModulosEnum} from "../ConstantsService";
import {TelaImprimirPedido} from "../TelaImprimirPedido";
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";
import {ModalPedidoStatusComponent} from "../modal-pedido-status/modal-pedido-status.component";

import {ModalOpendeliveryEventsComponent} from "../modal-opendelivery-events/modal-opendelivery-events.component";


import {timer} from "rxjs";
import {
  RazaoCancelamentoIfoodComponent
} from "../../componentes/razao-cancelamento-ifood/razao-cancelamento-ifood.component";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";
import {ModalRequestParceiroComponent} from "../modal-request-parceiro/modal-request-parceiro.component";
import {PayloadJsonViewComponent} from "../../pedidos/tela-pedidos-erros-importar/payload-json-view/payload-json-view.component";
import {AutorizacaoService} from "../../services/autorizacao.service";
import { NfceService } from '../../services/nfce.service';
import {ComissionamentoService} from "../../services/comissionamento.service";
import {PagamentosEletronicosService} from '../../services/pagamentos-eletronicos.service';
import {podeEstornarTransacaoConnectTef} from '../../pedidos/pagamentos-eletronicos/pagamento-eletronico-fluxo';
import {
  rotuloStatusFinanceiroConnectTef,
  rotuloStatusFiscalConnectTef,
} from '../../pedidos/pagamentos-eletronicos/pagamentos-eletronicos-apresentacao';
import {
  descrevaFormaDeEntrega as descrevaFormaDeEntregaPedido,
  obtenhaNomeLojaVenda as obtenhaNomeLojaVendaPedido
} from "../../pedidos/pedido-interloja-apresentacao";
@Component({
  selector: 'app-pedido-detalhes',
  templateUrl: './pedido-detalhes.component.html',
  styleUrls: ['./pedido-detalhes.component.scss']
})
export class PedidoDetalhesComponent extends TelaImprimirPedido implements OnInit , OnDestroy  {

  @ViewChild('razaoCancelmentoComp', { static: false}) razaoCancelmentoComp: any;
  @Input() modal = false;
  @Input() modoGrupoLojas = false;
  @Input() idEmpresa: any;
  FormaDeEntrega = FormaDeEntrega;
  descrevaFormaDeEntrega = descrevaFormaDeEntregaPedido;
  obtenhaNomeLojaVenda = obtenhaNomeLojaVendaPedido;
  carregou: boolean;
  configImpressao: any;
  processando: boolean;
  erroAceitar: string
  integracao: any;
  timerCancelamento: any;
  usuario: any = {}
  timerPedido
  historico = []
  carregandoHistorico = true;
  moduloFiadoAtivo = false;
  moduloComissionamentoAtivo = false;
  producaoPedidosHabilitada = false;
  comissionados: any[] = [];
  pedidoComissionamento: any;
  itemConfiguracaoComissao: any;
  comissoesConfiguracao: any[] = [];
  comissaoConfiguracaoId: number;
  carregandoComissoesConfiguracao = false;
  salvandoComissaoProduto = false;
  erroConfiguracaoComissao = '';
  mensagemErroNotaFiscal = '';
  mensagemSucessoNotaFiscal = '';
  baixandoXmlNotaFiscal = false;
  imprimindoNotaFiscal = false;
  mensagemSincronizacaoOpenDelivery = '';
  erroSincronizacaoOpenDelivery = '';
  carregandoOrigemOpenDelivery = false;
  erroOrigemOpenDelivery = '';
  moduloPagamentosEletronicosAtivo = false;
  transacoesConnectTef: any[] = [];
  carregandoTransacoesConnectTef = false;
  pagamentoEletronicoAberto = false;
  estornoConnectTefAberto = false;
  transacaoParaEstornoConnectTef: any;
  justificativaEstornoConnectTef = '';
  solicitandoEstornoConnectTef = false;
  erroEstornoConnectTef = '';
  constructor(private activatedRoute: ActivatedRoute, private router: Router,
              protected pedidosService: PedidosService, private _location: Location,
              private grupolojasService: GrupolojasService, private  dialogService: DialogService,
              private autorizacaoService: AutorizacaoService,
              private constantsService: ConstantsService,
              private comissionamentoService: ComissionamentoService,
              private pagamentosEletronicosService: PagamentosEletronicosService,
              impressao: ImpressaoService, protected nfeService: NfceService) {
    super(impressao, pedidosService, nfeService)

  }



  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      if(window.history.state.pedido) {
        this._pedido = window.history.state.pedido
        this.normalizeItensPedido(this._pedido);
        this.apliqueEmpresaDoPedidoEmModoGrupo();
      }

      let guid: string = params ?  params.guid : null;

      //outro pedido
      if(guid && guid !== this._pedido.guid)
        this._pedido = {};

      if(!this._pedido.id){
        if(guid)
          this.carreguePedidoCompleto(guid)
      } else if(!this._pedido.itens.length) {
        this.carreguePedidoCompleto(this._pedido.guid)
      } else {
        this.carregou = true;
        this.caregueRequestParceiro();
      }
    });

    this.constantsService.empresa$.subscribe( (empresa) => {
      if (!empresa) return;

      if(!this.modoGrupoLojas){
        this.empresa  = empresa;
        this.configImpressao = empresa.configImpressao;
        this.integracao = empresa.integracaoDelivery;
      }

      this.moduloFiadoAtivo = this.constantsService.possuiModulo(empresa, 'controle fiado');
      this.moduloComissionamentoAtivo = this.constantsService.possuiModulo(empresa, 'comissionamento');
      this.moduloPagamentosEletronicosAtivo = this.constantsService.possuiModulo(
        empresa, ModulosEnum.PAGAMENTOS_ELETRONICOS
      );
      if(this.moduloPagamentosEletronicosAtivo) this.carregueTransacoesConnectTef();
      this.producaoPedidosHabilitada = this.constantsService.possuiRecurso(empresa, 'estoque') && (empresa.producaoPedidosAtiva === true || Number(empresa.producaoPedidosAtiva) === 1);
      if(this.moduloComissionamentoAtivo)
        this.carregueComissionados();
    });

    this.usuario = this.autorizacaoService.getUser();

    this.timerPedido  =  timer(5000, 1000 * 30  ).subscribe( () => {
        this.busqueAlteracaoPedido();
    });
  }

  carregueComissionados() {
    this.comissionamentoService.listeComissionados({apenasAtivos: true}).then((comissionados: any[]) => {
      this.comissionados = this.normalizeComissionados(comissionados || []);
    }).catch(() => {});
  }

  produtoExigeComissionado(item: any) {
    const produto = item?.produto || {};
    const comissao = produto.comissao || {};
    const comissaoAtiva = comissao.ativo === true || comissao.ativo === 1;
    return this.moduloComissionamentoAtivo && !!comissao.id && comissaoAtiva;
  }

  produtoSemComissaoConfigurada(item: any) {
    return this.moduloComissionamentoAtivo && !!item?.produto?.id && !item.produto.comissao?.id;
  }

  abraModalConfiguracaoComissao(item: any) {
    this.itemConfiguracaoComissao = item;
    this.comissaoConfiguracaoId = null;
    this.comissoesConfiguracao = [];
    this.erroConfiguracaoComissao = '';
    this.carregandoComissoesConfiguracao = true;

    this.comissionamentoService.listeComissoes().then((comissoes: any[]) => {
      this.comissoesConfiguracao = (comissoes || []).map((comissao: any) => ({
        ...comissao,
        id: Number(comissao.id)
      }));
    }).catch((erro) => {
      this.erroConfiguracaoComissao = erro?.message || erro || 'Não foi possível carregar as comissões.';
    }).finally(() => {
      this.carregandoComissoesConfiguracao = false;
    });
  }

  fecheModalConfiguracaoComissao() {
    if(this.salvandoComissaoProduto)
      return;

    this.itemConfiguracaoComissao = null;
    this.comissaoConfiguracaoId = null;
    this.comissoesConfiguracao = [];
    this.erroConfiguracaoComissao = '';
  }

  salveConfiguracaoComissaoProduto() {
    if(!this.itemConfiguracaoComissao?.produto?.id || !this.comissaoConfiguracaoId || this.salvandoComissaoProduto)
      return;

    const produtoId = Number(this.itemConfiguracaoComissao.produto.id);
    const comissao = this.comissoesConfiguracao.find(
      (opcao: any) => Number(opcao.id) === Number(this.comissaoConfiguracaoId)
    );
    const catalogoId = Number(
      this.obtenhaEmpresaDoPedido()?.catalogo?.id || this.itemConfiguracaoComissao.produto.catalogo?.id
    );

    this.erroConfiguracaoComissao = '';
    this.salvandoComissaoProduto = true;
    this.comissionamentoService.vinculeProdutos(
      Number(this.comissaoConfiguracaoId),
      catalogoId,
      [produtoId]
    ).then(() => {
      (this._pedido?.itens || []).forEach((item: any) => {
        if(Number(item?.produto?.id) === produtoId)
          item.produto.comissao = comissao;
      });
      this.salvandoComissaoProduto = false;
      this.fecheModalConfiguracaoComissao();
    }).catch((erro) => {
      this.erroConfiguracaoComissao = erro?.message || erro || 'Não foi possível configurar a comissão do produto.';
      this.salvandoComissaoProduto = false;
    });
  }

  labelOperacionalComissionado() {
    const label = String(this._pedido?.empresa?.comissionadoLabel || this.empresa?.comissionadoLabel || 'Comissionado').trim();
    if(label.toLowerCase().endsWith('s'))
      return label.substring(0, label.length - 1);

    return label;
  }

  nomeComissionadoItem(item: any) {
    const comissionado = this.comissionados.find((opcao: any) => Number(opcao.id) === Number(item.comissionadoId));
    return comissionado?.nome || '';
  }

  abraModalComissionamento() {
    this.pedidoComissionamento = this._pedido;
  }

  fecheModalComissionamento() {
    this.pedidoComissionamento = null;
  }

  atualizeComissionadoNoPedido(itemComissionamento: any) {
    const itemPedido = (this._pedido?.itens || []).find((item: any) => Number(item.id) === Number(itemComissionamento.itemPedidoId));
    if(itemPedido)
      itemPedido.comissionadoId = itemComissionamento.comissionadoId || null;
  }

  private normalizeComissionados(comissionados: any[]) {
    return (comissionados || []).map((comissionado: any) => ({
      ...comissionado,
      id: Number(comissionado.id)
    }));
  }

  private normalizeItensPedido(pedido: any) {
    (pedido?.itens || []).forEach((item: any) => {
      item.comissionadoId = item.comissionadoId ? Number(item.comissionadoId) : null;
    });
  }

  carreguePedidoCompleto(guid){
    this.getService().obtenhaPorGuid(guid, this.idEmpresa).then( (pedido) => {
      this.carregou = true;
      this._pedido = pedido || {};
      this.normalizeItensPedido(this._pedido);
      this.apliqueEmpresaDoPedidoEmModoGrupo();

      this.caregueRequestParceiro();
    }).catch( (erro) => {
      this.carregou = true;
    });
  }

  busqueAlteracaoPedido(){
    if(!this._pedido || !this._pedido.id) return;

    if(this._pedido.finalizado || this._pedido.cancelado) return;

    this.getService().obtenhaPorGuid(this._pedido.guid, this.idEmpresa).then( (pedido) => {
      if (pedido && pedido.horarioAtualizacao !== this._pedido.horarioAtualizacao) {
        this.normalizeItensPedido(pedido);
        this._pedido = pedido
        this.apliqueEmpresaDoPedidoEmModoGrupo();
      }

    } ).catch( (erro) => { });

  }

  caregueRequestParceiro(){
    if(this._pedido.referenciaExterna || this._pedido.naoNotificado || this.obtenhaEmpresaDoPedido()?.integracaoFoodyDelivery){
       this.pedidosService.listeHistoricoRequests(this._pedido.id).then((requests: any) => {
        if(requests && requests.length)
          this._pedido.requests = requests;
      })
    }

    this.carregueHistoricoPedido();
    this.carregueTransacoesConnectTef();
  }

  carregueTransacoesConnectTef(): void {
    if(this.modoGrupoLojas || !this.moduloPagamentosEletronicosAtivo ||
      !this._pedido || !this._pedido.id || this.carregandoTransacoesConnectTef) return;
    this.carregandoTransacoesConnectTef = true;
    this.pagamentosEletronicosService.listeTransacoesPedido(this._pedido.id)
      .then((transacoes: any[]) => this.transacoesConnectTef = transacoes || [])
      .catch(() => this.transacoesConnectTef = [])
      .finally(() => this.carregandoTransacoesConnectTef = false);
  }

  abraPagamentoEletronico(): void {
    if(!this._pedido || !this._pedido.id) return;
    this.pagamentoEletronicoAberto = true;
  }

  concluaPagamentoEletronicoPedido(): void {
    this.pagamentoEletronicoAberto = false;
    this.carregueTransacoesConnectTef();
    if(this._pedido && this._pedido.guid) this.carreguePedidoCompleto(this._pedido.guid);
  }

  fechePagamentoEletronicoPedido(): void {
    this.pagamentoEletronicoAberto = false;
    this.carregueTransacoesConnectTef();
  }

  textoStatusConnectTef(status: string): string {
    return rotuloStatusFinanceiroConnectTef(status);
  }

  textoStatusFiscalConnectTef(status: string): string {
    return rotuloStatusFiscalConnectTef(status);
  }

  classeStatusConnectTef(status: string): string {
    if(['APPROVED', 'REVERSED'].indexOf(status) !== -1) return 'is-success';
    if(['REJECTED', 'ERROR', 'REVERSAL_REJECTED'].indexOf(status) !== -1) return 'is-danger';
    return 'is-warning';
  }

  podeEstornarConnectTef(transacao: any): boolean {
    return podeEstornarTransacaoConnectTef(transacao);
  }

  abraEstornoConnectTef(transacao: any): void {
    if(!this.podeEstornarConnectTef(transacao)) return;
    this.transacaoParaEstornoConnectTef = transacao;
    this.justificativaEstornoConnectTef = '';
    this.erroEstornoConnectTef = '';
    this.estornoConnectTefAberto = true;
  }

  fecheEstornoConnectTef(): void {
    if(this.solicitandoEstornoConnectTef) return;
    this.estornoConnectTefAberto = false;
    this.transacaoParaEstornoConnectTef = null;
    this.justificativaEstornoConnectTef = '';
    this.erroEstornoConnectTef = '';
  }

  async confirmeEstornoConnectTef(): Promise<void> {
    const justificativa = String(this.justificativaEstornoConnectTef || '').trim();
    if(!this.transacaoParaEstornoConnectTef || !justificativa) {
      this.erroEstornoConnectTef = 'Informe a justificativa do estorno.';
      return;
    }
    this.solicitandoEstornoConnectTef = true;
    this.erroEstornoConnectTef = '';
    try {
      await this.pagamentosEletronicosService.soliciteEstorno(
        this.transacaoParaEstornoConnectTef.identificacao, justificativa
      );
      this.solicitandoEstornoConnectTef = false;
      this.fecheEstornoConnectTef();
      this.carregueTransacoesConnectTef();
    } catch(erro) {
      this.erroEstornoConnectTef = String(erro && (erro.erro || erro.message) || erro ||
        'Não foi possível solicitar o estorno.');
      this.solicitandoEstornoConnectTef = false;
    }
  }

  carregueHistoricoPedido(){

    this.pedidosService.listeHistorico(this._pedido.guid).then((resposta: any) => {
        this.carregandoHistorico = false;
        this.historico = resposta;
    })
  }



  async editarPedido(pedido: any){
    const linkPedido = '/admin/pedidos/' + pedido.guid;

    if(!this.modoGrupoLojas){
      this.router.navigateByUrl(linkPedido);
      return;
    }

    const janelaPedido = window.open('', '_blank');

    try {
      await this.grupolojasService.prepareLojaV3CentralPedidos({
        empresaDestinoId: pedido.empresa.id,
        pedidoGuid: pedido.guid
      });

      const urlPedido = `https://${pedido.empresa.dominio}.meucardapio.ai${linkPedido}`;
      if(janelaPedido)
        janelaPedido.location.href = urlPedido;
      else
        window.open(urlPedido);
    } catch (erro) {
      if(janelaPedido) janelaPedido.close();
      alert(erro);
    }
  }

  sincronizarPedidoOpenDelivery($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    if(this._pedido.sincronizando) return false;

    this._pedido.sincronizando = true;
    this.mensagemSincronizacaoOpenDelivery = '';
    this.erroSincronizacaoOpenDelivery = '';
    const service: any = this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;
    service.sincronizePedidoOpenDelivery(this._pedido).then((pedido: any) => {
      this._pedido.sincronizando = false;
      if(pedido && pedido.id) Object.assign(this._pedido, pedido);
      this.mensagemSincronizacaoOpenDelivery = 'Pedido sincronizado com o parceiro.';
    }).catch((erro: any) => {
      this._pedido.sincronizando = false;
      this.erroSincronizacaoOpenDelivery = erro && (erro.message || erro) ||
        'Não foi possível sincronizar o pedido.';
    });
    return false;
  }

  async abraJsonOrigemOpenDelivery() {
    if(this.carregandoOrigemOpenDelivery) return;
    this.carregandoOrigemOpenDelivery = true;
    this.erroOrigemOpenDelivery = '';
    const pedido = this._pedido;
    const service = this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;
    try {
      const payload = await service.obtenhaOrigemPedidoOpenDelivery(pedido);
      const windowRef = this.dialogService.open({
        title: null,
        content: PayloadJsonViewComponent,
        minWidth: 250,
        width: Math.min(1200, window.innerWidth - 24),
        maxHeight: window.innerHeight - 32,
        cssClass: 'bsModal'
      });
      KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
      Object.assign(windowRef.content.instance, {
        payload,
        titulo: `Dados da API — Pedido #${pedido.codigo}`,
        descricao: 'Dados retornados pelo parceiro nesta consulta.',
        emTabela: true,
        dadosApi: true,
        canal: pedido.parceiro || pedido.externo?.sistema || 'OpenAPI',
        consultadoEm: new Date()
      });
    } catch(erro) {
      this.erroOrigemOpenDelivery = erro && (erro.message || erro) || 'Não foi possível consultar os dados da API.';
    } finally {
      this.carregandoOrigemOpenDelivery = false;
    }
  }

  abraModalEventosOpenDelivery(notificacoes = false){

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalOpendeliveryEventsComponent,
      minWidth: 250,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)


    windowRef.content.instance.pedido = this._pedido
    windowRef.content.instance.modoGrupoLojas = this.modoGrupoLojas;
    windowRef.content.instance.notificacoes = notificacoes;

    windowRef.result.subscribe( (result) => {  },
      (a) => {   });

  }

  abraModalRequestsParceiro(){
    //
    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalRequestParceiroComponent,
      minWidth: 800,
      width: window.innerWidth > 800 ? 800 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)


    windowRef.content.instance.pedido = this._pedido

    windowRef.result.subscribe( (result) => {  },
      (a) => {   });

    return false;
  }

  mudarStatusPedido(pedido: any) {

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalPedidoStatusComponent,
      minWidth: 250,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    windowRef.content.instance.modoGrupoLojas = this.modoGrupoLojas
    windowRef.content.instance.idEmpresa = this.idEmpresa || pedido?.empresa?.id
    windowRef.content.instance.pedido = pedido
    windowRef.content.instance.contato = pedido.contato;


    windowRef.result.subscribe( (result: any) => {
        if(result && result.id)
          Object.assign(pedido, result)
      } );

  }

   aceitarPedido(){
    if( this.processando ) return;

    delete this.erroAceitar;
    this.processando = true;

    this.getService().aceitePedido(this._pedido).then( async (resp) => {
      this._pedido.aceito = true;
      this._pedido.referenciaExterna = resp.referenciaExterna;
      if(resp.erroNotificar)
        this.erroAceitar = resp.erroNotificar
      this.processando = false;

      await this.envieImpressaoAutomatica();
    }).catch( erro => {
      this.processando = false;
      this.erroAceitar = erro;
    })
  }


  rejeitarPedido(){
    if( this.processando ) return;

    delete this.erroAceitar;
    delete this._pedido.motivoRejeicao;
    this.processando = true;

    let razao = this._pedido.origemExterna && this.razaoCancelmentoComp ?  this.razaoCancelmentoComp.razaoCancelamento : null

    this.getService().rejeitePedido(this._pedido, razao).then( (resp) => {
      if(!resp.aguardandoPdv){
        this.setPedidoCancelado(resp)
      } else {
        this._pedido.aguardandoPdv = true;
        this.inicieMonitoramentoCancelamento(resp.idEvent);
      }
    }).catch( erro => {
      this.processando = false;
      this.erroAceitar = erro;
    })

  }

  setPedidoCancelado(resp: any){
    this.processando = false;
    this._pedido.cancelado = true;
    this._pedido.status =  resp.status;
    this._pedido.statusOrdem = resp.statusOrdem;
  }

  inicieMonitoramentoCancelamento(idEvent){
    let segundosTimer = 5;
    this.timerCancelamento =  timer(2000, 1000 * segundosTimer  ).subscribe( () => {
      console.log('verificar pedido: ' + this._pedido.id)
      this.getService().obtenhaStatusCancelamento(this._pedido, idEvent).then( (resposta: any) => {
        if(resposta.pdvReconheceu)  this._pedido.pdvReconheceu = true;

        if(resposta.rejeitouCancelamento){
          this._pedido.motivoRejeicao  =  resposta.motivo;
          this.pareMonitoramento();
        }

        if(resposta.cancelado){
          this.setPedidoCancelado(resposta);
          this.pareMonitoramento();
        }
      })
    });
  }

  ngOnDestroy(): void {
    this.pareMonitoramento();
  }

  pareMonitoramento(){
    this._pedido.aguardandoPdv = false;
    this.processando = false;

    if( this.timerCancelamento)
      this.timerCancelamento.unsubscribe();

    if(this.timerPedido)
      this.timerPedido.unsubscribe();
  }

  notifiqueSistemaIntegrado() {
    if( this.processando ) return;

    delete this.erroAceitar;
    this.processando = true;

    delete this._pedido.erroExterno;

    this.getService().notifiqueSistemaIntegrado(this._pedido).then( (resp) => {
      this._pedido.referenciaExterna = resp;
      this.processando = false;
    }).catch( erro => {
      this.processando = false;
        this._pedido.erroExterno = erro;
    })
  }



  voltar() {
    this._location.back();
  }

  imprimaPedidoDoLayout(){
    this.imprimaPedido(this.configImpressao ? this.configImpressao.layoutPedido : 'PedidoCompleto');
  }

  async imprimaPedido(layoutPedido: string) {
    if(!this.configImpressao  || !this.configImpressao.imprimirTXT)
      window.open('/imprimir/pedido/' + this._pedido.guid + '?l=' + layoutPedido);
    else
      await this.imprimaNaImpressora(null, layoutPedido)
  }

  obtenhaNfcePedido(): any {
    return this._pedido?.nfce || this._pedido?.notaFiscal;
  }

  obtenhaStatusNfce(status: number): string {
    const statusNfce: any = {
      1: 'Nova',
      2: 'Autorizada',
      3: 'Em processamento',
      4: 'Cancelada',
      5: 'Inutilizada',
      6: 'Importada',
      7: 'Contigenciada',
      8: 'De contingencia',
      9: 'Duplicidade',
      10: 'Rejeitada',
      11: 'Dados invalidos',
      12: 'Sucesso',
      13: 'Falha',
      14: 'Conferencia rejeitou',
      15: 'Presa na SEFAZ',
      16: 'Problemas no envio',
      17: 'Envio interrompido',
      18: 'Problema comunicacao SEFAZ',
      19: 'Denegada',
      20: 'Recebida',
      21: 'Pendente de conciliacao',
      22: 'Rejeitada e pendente de conciliacao',
      23: 'Problemas no envio em contingencia',
      24: 'Problema ao cancelar NFe'
    };

    return statusNfce[status] || String(status);
  }

  obtenhaClasseStatusNfce(status: number): string {
    if (status === 2) {
      return 'badge-success';
    }

    if ([1, 3, 15, 20].includes(status)) {
      return 'badge-warning';
    }

    if ([10, 11, 14, 16, 17, 18, 19, 22, 23, 24].includes(status)) {
      return 'badge-danger';
    }

    return 'badge-info';
  }

  formatChaveAcesso(chave: string): string {
    if (!chave) return '';
    return chave.match(/.{1,4}/g)?.join(' ') || chave;
  }

  abrirDanfeNfcePedido(): void {
    const nfce = this.obtenhaNfcePedido();
    if (!nfce?.id) return;

    window.open('/nfce/' + nfce.id + '/danfe', '_blank');
  }

  async baixarXmlNfcePedido(): Promise<void> {
    const nfce = this.obtenhaNfcePedido();
    if (!nfce?.id) return;

    try {
      this.baixandoXmlNotaFiscal = true;
      this.mensagemErroNotaFiscal = '';
      this.mensagemSucessoNotaFiscal = '';

      const blob = nfce.status === 2
        ? await this.nfeService.obtenhaXmlDistribuicao(nfce.id)
        : await this.nfeService.obtenhaXmlNota(nfce.id);

      this.baixeArquivo(blob, this.obtenhaNomeArquivoXmlNfce(nfce));
    } catch (erro) {
      this.mensagemErroNotaFiscal = 'Erro ao baixar o XML da nota fiscal.';
    } finally {
      this.baixandoXmlNotaFiscal = false;
    }
  }

  async imprimirNfcePedido(): Promise<void> {
    const nfce = this.obtenhaNfcePedido();
    if (!nfce?.id || this.imprimindoNotaFiscal) return;

    try {
      this.imprimindoNotaFiscal = true;
      this.mensagemErroNotaFiscal = '';
      this.mensagemSucessoNotaFiscal = '';

      const empresa = this.obtenhaEmpresaParaImpressaoNfce();
      const impressoras = empresa?.configImpressao?.impressoras?.filter((impressora: any) => impressora.imprimirNFCe) || [];

      if (!impressoras.length) {
        this.abrirDanfeNfcePedido();
        return;
      }

      const dadosImpressao = await this.nfeService.obtenhaDadosImpressao(nfce.id);
      let imprimiu = false;

      for (const impressora of impressoras) {
        imprimiu = (await this.impressao.imprimaNfceNaImpressora(dadosImpressao, impressora)) || imprimiu;
      }

      if (imprimiu) {
        await this.nfeService.marqueImpressa(nfce);
        this.mensagemSucessoNotaFiscal = 'NFC-e enviada para impressao com sucesso.';
      }
    } catch (erro) {
      this.mensagemErroNotaFiscal = 'Erro ao imprimir a nota fiscal.';
    } finally {
      this.imprimindoNotaFiscal = false;
    }
  }



  async imprimaNaImpressora(impressora: any = null, layoutPedido: string  = null ) {
    if(this.configImpressao.multiplasImpressoras){
      await this.imprimaAutomaticamente(impressora);
    } else {
      let impressoraPadrao = this.configImpressao.impressoras[0];

      impressoraPadrao.layout =  layoutPedido || this.configImpressao.layoutPedido;

      await this.imprimaAutomaticamente(impressoraPadrao);
    }
  }


  private async imprimaAutomaticamente(impressora: any) {
    try {
      await this.impressao.imprimaPedidoNaImpressora(this._pedido, impressora)
    } catch(erro) {
      console.error(erro)
      // Não use alert, deixe o sistema de notificações do ImpressaoService tratar o erro
      // O erro já será automaticamente emitido pelo método imprimaPedidoNaImpressora
    }
  }

  getService() {
    if (this.modoGrupoLojas)
      return this.grupolojasService;

    return this.pedidosService;
  }


  obtenhaItens(empresa: any) {
    return  this._pedido.itens.filter((item: any) => !item.empresa || item.empresa.id === empresa.id);
  }

  verPedidoExterno(_pedido: any) {

  }

  pathExterno() {
    return this._pedido.externo?.sistema?.toLowerCase()
  }

  get badgeParceiroExterno(): string {
    const parceiro = String(this._pedido?.parceiro || this._pedido?.externo?.sistema || '').trim().toLowerCase();
    return ['aiqfome', 'aiquefome'].includes(parceiro) ? 'badge-aiqfome' : this._pedido?.externo?.badge || '';
  }

  private obtenhaEmpresaParaImpressaoNfce(): any {
    return this._pedido?.empresa || this.empresa;
  }

  private obtenhaEmpresaDoPedido(): any {
    if(this.modoGrupoLojas && this._pedido?.empresa)
      return this._pedido.empresa;

    return this.empresa;
  }

  private apliqueEmpresaDoPedidoEmModoGrupo(): void {
    if(!this.modoGrupoLojas || !this._pedido?.empresa) return;

    this.empresa = this._pedido.empresa;
    this.configImpressao = this._pedido.empresa.configImpressao;
    this.integracao = this._pedido.empresa.integracaoDelivery;
    this.moduloFiadoAtivo = this.constantsService.possuiModulo(this._pedido.empresa, 'controle fiado');
    this.moduloComissionamentoAtivo = this.constantsService.possuiModulo(this._pedido.empresa, 'comissionamento');
    this.producaoPedidosHabilitada = this.constantsService.possuiRecurso(this._pedido.empresa, 'estoque') && (this._pedido.empresa.producaoPedidosAtiva === true || Number(this._pedido.empresa.producaoPedidosAtiva) === 1);
  }

  private baixeArquivo(blob: Blob, nomeArquivo: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  private obtenhaNomeArquivoXmlNfce(nfce: any): string {
    const identificador = nfce.chaveDeAcesso || 'nfce-' + nfce.id;
    const sufixo = nfce.status === 2 ? 'procNFe' : 'nfe';

    return `${identificador}-${sufixo}.xml`;
  }

}

export enum FormaDeEntrega {
  RECEBER_EM_CASA = 'Receber em casa',
  RETIRAR = 'Retirar'
}
